/* tslint:disable */
/* eslint-disable */
/**
 * Bfree API
 * API Documentation for B&Free Project
 *
 * The version of the OpenAPI document: 0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * 
 * @export
 * @enum {string}
 */
export enum VerificationCodeType {
    Email = 'EMAIL',
    Phone = 'PHONE'
}

export function VerificationCodeTypeFromJSON(json: any): VerificationCodeType {
    return VerificationCodeTypeFromJSONTyped(json, false);
}

export function VerificationCodeTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): VerificationCodeType {
    return json as VerificationCodeType;
}

export function VerificationCodeTypeToJSON(value?: VerificationCodeType | null): any {
    return value as any;
}

